import Api from "../../../../util/Api";

export default function getInitState() {
    return {
        dataTableOptions: {
            initOnRender: false
        },
        actions: [
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn btn-primary",
                event_payload: 'showSearchModal'
            },
            {
                btn_text: '<i class="fas fa-plus"></i> Exportálás',
                event_name: "customClick",
                class: "btn btn-success",
                event_payload: 'export'
            },
        ],
        searchFields: [
            {
                name: "dateFrom",
                label: "Időszaktól",
                formType: "date",
                formSize: 3
            },
            {
                name: "dateTo",
                label: "Időszakig",
                formType: "date",
                formSize: 3
            },
            {
                name: "treatmentTypeId",
                label: "Kezelés",
                formSize: 3,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getAllTreatmentType,
                    formatText: function (val) {
                        return val.title;
                    },
                    formatOption: function (val) {
                        return val.title;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'title',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "siteId",
                label: "Telephely",
                formSize: 3,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getCompanySitesByCompanyId,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'keresés',
                        noResults: 'Nincs találat'
                    }
                },
            },
            {
                name: "ageFilterOperator",
                label: "Életkor operátor",
                formSize: 3,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getFilterOperators,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "ageFilter",
                label: "Életkor",
                formSize: 3,
                formType: "number"
            },
            {
                name: "sex",
                label: "Nem",
                formSize: 3,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getSexOptions,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'text',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
            },
            {
                name: "region",
                label: "Régió",
                formSize: 3,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.listRegionsForSelect,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'text',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "isForeign",
                label: "Külföldi?",
                formSize: 3,
                formType: "checkbox"
            }
        ],
        headerFields: [
            {
                name: "treatmentDate",
                label: "Kezelés dátuma",
                visibility: true,
                slot_name: "date_format",
                sort: true
            },
            {
                name: "treatmentType",
                label: "Kezelés",
                visibility: true,
                sort: true
            },
            {
                name: "siteName",
                label: "Telephely",
                visibility: true
            },
            {
                name: "age",
                label: "Kor",
                visibility: true
            },
            {
                name: "sex",
                label: "Nem",
                visibility: true
            },
            {
                name: "region",
                label: "Régió",
                visibility: true,
                sort: true
            },
            {
                name: "countyName",
                label: "Megye",
                visibility: true
            },
            {
                name: "isForeign",
                label: "Külföldi",
                visibility: true,
                slot_name: "isBasic_format"
            },
            {
                name: "treatmentCount",
                label: "Darab",
                visibility: true,
            }
        ]
    }
}
